import { IconProps } from '.';

const StoriesIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 36 30"
      fill="none"
    >
      <path
        className={customClasses}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8391 0.729639C9.3117 0.312451 10.021 0.312451 10.4936 0.729639L18.8269 8.08596C19.0957 8.32324 19.2497 8.66453 19.2497 9.02307V16.0212L25.5361 10.8187C26.01 10.4264 26.699 10.4374 27.1603 10.8446L35.4936 18.2009C35.7624 18.4382 35.9163 18.7795 35.9163 19.138V28.3334C35.9163 29.0238 35.3567 29.5834 34.6663 29.5834H1.33301C0.642652 29.5834 0.0830078 29.0238 0.0830078 28.3334V9.02307C0.0830078 8.66453 0.236971 8.32324 0.505767 8.08596L8.8391 0.729639ZM16.7497 18.6698C16.7496 18.6759 16.7496 18.682 16.7497 18.688V27.0834H2.58301V9.58698L9.66634 3.33411L16.7497 9.58698V18.6698ZM19.2497 27.0834V19.2663L26.3068 13.4259L33.4163 19.7019V27.0834H19.2497Z"
        fill={color}
      />
    </svg>
  );
};

export default StoriesIcon;
